import type { TFunction } from "i18next";
import { panelNodeKindFor } from "./fluss-node-panel-utils";

// Validation issues already carry a Fluss kind; diagram routes carry a BPMN business object.
export const flussNodeTypeLabel = (businessObject: any | string | null | undefined, t: TFunction): string => {
    if (!businessObject) return "";
    const kind = typeof businessObject === "string"
        ? businessObject
        : panelNodeKindFor({
            id: businessObject.id || "",
            type: businessObject.$type || "",
            businessObject,
            element: null,
        });
    if (!kind || kind === "unsupported") return "";
    const key = `fluss.node_panel.type.${kind}`;
    const translated = String(t(key, { defaultValue: "" }));
    return translated === key ? "" : translated;
};
